import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { hapticButtonPress } from '../utils/hapticsUtils';
import './BottomNav.css';

const BottomNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  const handleNavClick = (path: string) => {
    hapticButtonPress();
    navigate(path);
  };

  return (
    <div className="bottom-nav">
      <button 
        className={`nav-item ${isActive('/home') ? 'active' : ''}`}
        onClick={() => handleNavClick('/home')}
      >
        <div className="nav-icon">🏠</div>
        <div className="nav-label">Home</div>
      </button>

      <button 
        className={`nav-item ${isActive('/levels') || isActive('/chapters') || isActive('/chapter') || isActive('/lesson') ? 'active' : ''}`}
        onClick={() => handleNavClick('/levels')}
      >
        <div className="nav-icon">📚</div>
        <div className="nav-label">Level</div>
      </button>

      <button 
        className={`nav-item ${isActive('/quizzes') || isActive('/quiz') ? 'active' : ''}`}
        onClick={() => handleNavClick('/quizzes')}
      >
        <div className="nav-icon">📝</div>
        <div className="nav-label">Quizzes</div>
      </button>

      <button 
        className={`nav-item ${isActive('/profile') || isActive('/settings') ? 'active' : ''}`}
        onClick={() => handleNavClick('/profile')}
      >
        <div className="nav-icon">👤</div>
        <div className="nav-label">Profile</div>
      </button>
    </div>
  );
};

export default BottomNav;

